<div class="m-container">
    <p>My Order Detail</p>
    <hr>
    <img class="ticket-type" src="./../../../../../assets/img/1-day-selected.svg" alt="">
</div>

<div id="aba_main_modal" class="aba-modal" *ngIf="paymentForm">
    <div class="aba-modal-content">
        <form method="POST" class="hidden" target="aba_webservice" [action]="paymentData.action_url" id="aba_merchant_request">
            <input type="hidden" *ngFor="let key of paymentForm | keyvalue" [name]="key.key" [value]="key.value" [id]="key.key">
        </form>
    </div>
</div>